var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.7,
    height: 18.381,
    viewBox: "0 0 13.7 18.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-908 -231.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8306",
    "data-name": "Path 8306",
    d: "M909.245,239.9a.924.924,0,0,0,.924.886H918.8a.925.925,0,0,0,.924-.886l.617-13.019H908.628Zm7.2-9.785a.376.376,0,0,1,.376-.376h.6a.376.376,0,0,1,.376.376v7.438a.375.375,0,0,1-.376.375h-.6a.376.376,0,0,1-.376-.375Zm-2.629,0a.375.375,0,0,1,.375-.376h.6a.376.376,0,0,1,.376.376v7.438a.375.375,0,0,1-.376.375h-.6a.375.375,0,0,1-.375-.375v-7.438Zm-2.63,0a.376.376,0,0,1,.376-.376h.6a.375.375,0,0,1,.375.376v7.438a.375.375,0,0,1-.375.375h-.6a.375.375,0,0,1-.376-.375Z",
    transform: "translate(0.371 9)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8307",
    "data-name": "Path 8307",
    d: "M920.757,223.349h-3.985V222.6a.193.193,0,0,0-.193-.193H912.4a.194.194,0,0,0-.194.193v.754h-3.984a.58.58,0,0,0-.58.58v1.824h13.7v-1.824A.58.58,0,0,0,920.757,223.349Z",
    transform: "translate(0.363 9)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2b04a47b29e1a32591b54106d118c28f.svg";
export { ForwardRef as ReactComponent };